<template>
  <div id="OrgRealNameTime">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业实名认证期限</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">实名认证期限：</div>
          <div class="panel-body-row-right">
            <template v-if="orgInfo.authStatus == '1'">
              {{realAutheTime.startDate | dateFormatYMD}} 至 {{realAutheTime.endDate |dateFormatYMD}}
            </template>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'OrgRealNameTime',
  components: {
    ebPanel,
    ebPanelHeader
  },
  props: {
    orgInfo: {},
    realAutheTime: {}
  }
};
</script>
<style scoped lang="less">
</style>
